import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, CmsService, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { ContentService } from '../../spartacus/services/content.service';
import { MatDialog } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ExternalLinkModalComponent } from '../../cms-common/external-link-modal/external-link-modal.component';
import { UserInfoService } from '../../spartacus/services/user-info.service';
@Component({
    selector: 'app-custom-banner',
    templateUrl: './custom-banner.component.html',
    styleUrls: ['./custom-banner.component.scss'],
    standalone: false
})
export class CustomBannerComponent {
  node:Observable<any> = this.bannerComponent.data$;
  calendlyData: any;
  showCalendly: boolean=false;
  isAsAgent: boolean = false;
  popupdata: any;
  constructor(private cmsService:CmsService, protected config: OccConfig,public bannerComponent: CmsComponentData<CmsBannerComponent>,private cd: ChangeDetectorRef,private contentservice: ContentService, private dialog: MatDialog,
    private overlay: Overlay, private userInfoService: UserInfoService) {
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.desktop?.url;
  }
  getImage1(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
  ngOnInit(): void {
    this.isAsAgent = this.userInfoService.checkAsmUser();
    this.contentservice.getNavigation('calendlyPopUp').subscribe(res => {
      this.popupdata = res;
    });
  }
  ngAfterViewInit() {
    this.contentservice.vsscontent().subscribe(value => {
      this.calendlyData = value;
      this.cd.detectChanges();
    })
  }

  openCalendly(): void {
    if (this.isAsAgent) {
      return;
    }
  this.dialog.open(ExternalLinkModalComponent, {
    scrollStrategy: this.overlay.scrollStrategies.noop(),
    data: {
      popupdata: this.popupdata,
      url: this.calendlyData?.calendlyId
    },
    disableClose: true,
    hasBackdrop: true,
    autoFocus: false,
    restoreFocus: true,
    panelClass: 'external-link-dialog-panel',
    backdropClass: 'custom-backdrop'
  });
}
}
